[
  {
    "code": "PF-TI",
    "name": "Austral Islands"
  },
  {
    "code": "PF-LI",
    "name": "Leeward Islands"
  },
  {
    "code": "PF-MI",
    "name": "Marquesas Islands"
  },
  {
    "code": "PF-TG",
    "name": "Tuamotu-Gambier"
  },
  {
    "code": "PF-WI",
    "name": "Windward Islands"
  }
]